// extracted by mini-css-extract-plugin
module.exports = {"chart-container":"StockCommodityMovesChart_chart-container__vItDE"};